import { Navigate, Route, Routes } from 'react-router-dom';
import { InboxesListPage } from './InboxesList';
import { InboxDetailsPage } from './InboxDetail';

export const InboxPage: React.FC = () => {
  return (
    <Routes>
      <Route element={<InboxesListPage />} path="/" />
      <Route element={<InboxDetailsPage />} path="/:id" />
      <Route path="/" element={<Navigate replace to="/inbox" />} />
    </Routes>
  );
};
